const getParentName = (name, route) => {
  const nameTokens = name.split('.');

  if (nameTokens.length > 1) {
    return nameTokens.slice(0, nameTokens.length - 1).join('.');
  }

  return route.parent;
};

export const toRoutePath = (routes, name) => {
  const route = routes[name];

  if (!route) {
    return '';
  }

  const routeUrl = route.url.split('?')[0];

  const parentName = getParentName(name, route);

  return parentName
    ? `${toRoutePath(routes, parentName)}${routeUrl}`
    : routeUrl;
};
